
import React from 'react';
import ReactDOM from 'react-dom';
import Footer from '/home/circleci/app/node_modules/@fiverr-private/footer/entries/Default';

const element = typeof document !== 'undefined' && document.querySelector('#Footer');

if (element) {
    const props = window.initialData['Footer'];

    ReactDOM.render(
        <Footer {...props}/>,
        element
    );
}

export default Footer;
